import { ComponentProps, ElementType, Fragment } from 'react';

type Props<T extends ElementType = 'div'> = {
    as?: T;
} & ComponentProps<T>;
export const As = <T extends ElementType = 'div'>({ as: Element = 'div', children, ...props }: Props<T>) => {
    return <Element {...(Element === Fragment ? {} : props)}>{children}</Element>;
};
